mutation createMarketSplit($market_id: String!, $split_factor: String!, $price_multiplier: Float!, $split_date: Float!) {
    createMarketSplit(market_id: $market_id, split_factor: $split_factor, price_multiplier: $price_multiplier, split_date: $split_date)
}
